import { Injectable } from '@angular/core';
import { MapLayer } from '../interfaces/map';

@Injectable()
export class MapLayerCacheService {
  private poiCache: MapLayer[] = [];
  private maintainersCache: MapLayer[] = [];

  getPOICache(): MapLayer[] {
    return this.poiCache;
  }

  getMaintainersCache(): MapLayer[] {
    return this.maintainersCache;
  }

  updatePOICache(layers: MapLayer[]): void {
    this.poiCache = layers;
  }

  updateMaintainersCache(layers: MapLayer[]): void {
    this.maintainersCache = layers;
  }

  hasPOI(): boolean {
    return this.poiCache.length > 0;
  }

  hasMaintainers(): boolean {
    return this.maintainersCache.length > 0;
  }
}
